export default {
  title: 'Ny pris',
  fields: {
    product: {
      label: 'Produkt',
    },
    is_not_personal: {
      label: 'Synlig for alle',
    },
    is_default: {
      label: 'Standard',
    },
    visible_to: {
      label: 'Synlig for',
    },
  },
  buttons: {
    select_all: 'Vælg alle',
    save: 'Gem',
    cancel: 'Annuller',
  },
  feedback: {
    missing_info: 'Manglende oplysninger',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    price_got_created: 'Prisen blev oprettet',
    price_got_updated: 'Prisen blev opdateret',
  },
};
